import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { useRootStore } from "store";
import { PrimaryButton } from "components/button/Button";
import { Checkbox } from "components/checkbox/Checkbox";
import { Input } from "components/input/Input";
import config from "config/config";

import "./InviteUser.scss";

export default function InviteUser() {
  const navigate = useNavigate();
  const { isAuthenticated, setPasswordAndGetAuthFromKey } = useRootStore(
    (state) => state.user
  );
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [acceptedAgreement, setAcceptedAgreement] = useState(false);

  const { key } = useParams();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (key) {
      setPasswordAndGetAuthFromKey(key, password1);
    }
    return;
  };

  const getPasswordFeedback = () => {
    if (!password1 || !password2) {
      return "";
    }

    const gotNumbers = password1.match(/\d/g) || [];
    const gotBigLetters = password1.match(/[A-ZÅÄÖ]/g) || [];
    const gotSmallLetters = password1.match(/[a-zåäö]/g) || [];

    return password1.length < 8
      ? "Lösenordet måste minst vara åtta tecken långt"
      : gotNumbers.length < 2
        ? "Lösenordet måste minst innehålla två siffror"
        : gotBigLetters.length < 1
          ? "Lösenordet måste minst innehålla en stor bokstav"
          : gotSmallLetters.length < 2
            ? "Lösenordet måste minst innehålla två små bokstäver"
            : password1 !== password2
              ? "Lösenord matchar ej"
              : "";
  };

  const isValidPassword = () => {
    return getPasswordFeedback().length === 0;
  };

  const formIsValid = () => {
    return isValidPassword() && acceptedAgreement;
  };

  return (
    <div className="box">
      <h1>Välj ett lösenord</h1>
      <hr className="header-border" />

      <p>
        Välj ett lösenord och godkänn användarvillkoren. När du klickar på
        knappen "Bekräfta lösenord" kommer du bli inloggad i MittKontor.
      </p>

      <form onSubmit={(e) => handleSubmit(e)}>
        <p>
          Lösenordet måste vara minst 8 tecken långt, innehålla en stor bokstav,
          två små bokstäver och minst två numeriska tecken.
        </p>
        <div>
          <Input
            className="mb-2"
            type="password"
            placeholder="Ange lösenord"
            onChange={(e) => setPassword1(e.target.value)}
          />
        </div>
        <Input
          type="password"
          placeholder="Upprepa ditt lösenord"
          onChange={(e) => setPassword2(e.target.value)}
        />
        <div className="errorMessage">{getPasswordFeedback()}</div>
        <p>
          Innan tjänsten MittKontor kan användas måste du som användare godkänna
          ett användaravtal för MittKontor. Användaravtalet syftar till att
          skyldigheter och rättigheter upprätthålls mellan dig som kund och
          Ludvig &amp; Co.
        </p>
        <div className="consent">
          <Checkbox
            className="mr-2"
            name="accepted"
            checked={acceptedAgreement}
            onClick={() => setAcceptedAgreement(!acceptedAgreement)}
            text={
              <>
                Jag godkänner{" "}
                <a
                  href={config.static.licenseAgreement}
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  användarvillkoren
                </a>
                .
              </>
            }
          />
        </div>
        <div className="mt-4 mb-4">{getPasswordFeedback()}</div>
        <PrimaryButton type="submit" disabled={!formIsValid()}>
          Bekräfta lösenord
        </PrimaryButton>
      </form>
    </div>
  );
}
